import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTenant } from '../context/TenantContext';
import DOMPurify from 'dompurify';

const CookiePolicy = () => {
  const { t } = useLanguage();
  const { tenant } = useTenant();

  // Add CSS for links in Cookie Policy content
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .cookie-content a {
        color: #2563eb !important;
        text-decoration: underline !important;
        cursor: pointer !important;
      }
      .cookie-content a:hover {
        color: #1d4ed8 !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  // Debug: Check what content we're getting
  useEffect(() => {
    if (tenant?.cookiepolicy) {
      console.log('=== Cookie Policy Content Debug ===');
      console.log('Raw content (first 1000 chars):', tenant.cookiepolicy.substring(0, 1000));
      console.log('Has <div> tags:', tenant.cookiepolicy.includes('<div'));
      console.log('Has <p> tags:', tenant.cookiepolicy.includes('<p>'));
      console.log('Has <br> tags:', tenant.cookiepolicy.includes('<br'));
      console.log('Has &lt; encoded:', tenant.cookiepolicy.includes('&lt;'));
      console.log('Sanitized output:', DOMPurify.sanitize(tenant.cookiepolicy).substring(0, 1000));
      console.log('===================================');
    }
  }, [tenant?.cookiepolicy]);

  return (
    <div className="max-w-3xl mx-auto p-4 lg:p-8 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <h1 className="text-xl md:text-2xl font-bold text-theme-secondary">
          {t('cookiePolicy.title') || 'Cookie Policy'}
        </h1>
      </div>

      {/* Cookie Policy Content */}
      <div className="text-gray-700">
        {tenant?.tenantcontentconfig?.CookiePolicy?.isLink ? (
          <a
            href={tenant?.tenantcontentconfig?.CookiePolicy?.link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-theme-primary hover:underline text-lg font-medium"
          >
            {tenant?.tenantcontentconfig?.CookiePolicy?.linkName}
          </a>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(tenant?.cookiepolicy || ''),
            }}
            className="cookie-content"
            style={{ textAlign: 'left' }}
          />
        )}
      </div>
    </div>
  );
};

export default CookiePolicy;
